/**
 * built-in web client version; must match pom.xml, manifest.mf and plugin.xml!
 */
const  BUILTIN_PSAWEBCLI_VER = '8.4.0.20260408054500';
export { BUILTIN_PSAWEBCLI_VER };